require('./mortgageRequestMovingExpenses.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const classNames = require('classnames');

// @ components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKSliderInput = require('commonsComponents/OKSliderInput');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @ constants
const { EURO_SYMBOL } = require('constants/index');
const { text } = require('./initialValues');
const NEW_OFFER = 'newOffer';
const CURRENT_OFFER = 'currentOffer';

// @ helper
const { FormattedText, formatText } = require('core/i18n').i18n;
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp.js');

class MortgageRequestMovingExpenses extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            financeExpensesValue: 0,
            selectedOffer: '',
            isTermsChecked: false,
            isCalculated: false
        }
        this.handleChangeSliderValue = this.handleChangeSliderValue.bind(this);
        this.handleOnSave = this.handleOnSave.bind(this);
        this.handleSelectBox = this.handleSelectBox.bind(this);
        this.handleCalculate = this.handleCalculate.bind(this);
        this.handleTermsChanged = this.handleTermsChanged.bind(this);
    }

    componentDidMount() {
        const { immMortgageRequestMortgageData } = this.props;
        const data = immMortgageRequestMortgageData.get('data');
        const selectedOffer = data.get('importeFinanciarGastos') === 0 ? CURRENT_OFFER : NEW_OFFER;
        const financeExpensesValue = data.get('importeFinanciarGastos') || data.get('maximoImporteFinanciarGastos');

        if (!!financeExpensesValue) {
            this.setInitialFinanceExpensesValue(financeExpensesValue, selectedOffer);
        }
    }

    setInitialFinanceExpensesValue(financeExpensesValue, selectedOffer) {
        this.setState({
            financeExpensesValue,
            selectedOffer
        }, () => this.handleCalculate());
    }

    handleCalculate() {
        const { onCalculateMovingFee } = this.props;
        const { financeExpensesValue } = this.state;

        onCalculateMovingFee(financeExpensesValue);

        this.setState({
            isCalculated: true
        });
    }

    handleCancelMovingExpenses() {
        this.props.history.push('/myprofile/mortgage/panel');
    }

    handleChangeSliderValue(value) {
        const financeExpensesValue = Number(value);

        this.setState({
            financeExpensesValue
        });
    }

    handleOnSave() {
        const { onAcceptMovingFee } = this.props;
        const { selectedOffer } = this.state;
        let { financeExpensesValue } = this.state;

        if (selectedOffer === CURRENT_OFFER) {
            financeExpensesValue = 0;
        }

        onAcceptMovingFee(financeExpensesValue);
    }

    handleSelectBox(e) {
        const { isCalculated } = this.state;
        const type = e.target.dataset.type;
        const parent = e.target.parentNode;
        const selectedOffer = !!type ? type : parent.dataset.type;

        if (selectedOffer === NEW_OFFER && !isCalculated) {
            return;
        }

        this.setState({
            selectedOffer
        });
    }

    handleTermsChanged(evt) {
        this.setState({
            isTermsChecked: evt.target.checked
        });
    }

    buildBox(config) {
        const { immMortgageRequestMortgageData, immMortgageRequestMovingExpensesData } = this.props;
        const { isCalculated } = this.state;

        const boxType = config.isLeftBox ? CURRENT_OFFER : NEW_OFFER;
        const isCurrentOffer = boxType === CURRENT_OFFER;

        const titleKey = isCurrentOffer ? 'mortgageRequestMovingExpenses-mortgageRequestMovingExpenses_boxTitleNoExpenses' : 'mortgageRequestMovingExpenses-mortgageRequestMovingExpenses_boxTitle';
        const currentOfferValue = immMortgageRequestMortgageData.getIn(['data', 'cuotaMensual']);
        const newOfferValue = isCalculated ? immMortgageRequestMovingExpensesData.get('newOffer') : 0;
        const value = isCurrentOffer ? currentOfferValue : newOfferValue;
        const valueWithCurrency = value !== 0 ? MortgageRequestCurrencyHelp({ currency: value }) : '--';

        const boxClasses = classNames(
            'mortgage-request-moving-expenses__box',
            {
                'mortgage-request-moving-expenses__box--selected': config.selected,
                'mortgage-request-moving-expenses__box--fetching': config.isFetching
            }
        );

        const boxAmountClasses = classNames('mortgage-request-moving-expenses__box-amount', {
            'mortgage-request-moving-expenses__box-amount--selected': config.selected
        })

        const boxIconClasses = classNames('icon mortgage-request-moving-expenses__box-icon', {
            'icon-checkmark mortgage-request-moving-expenses__box-icon--selected': config.selected
        });

        const boxContent = (
            <React.Fragment>
                <FormattedText value={titleKey} className="mortgage-request-moving-expenses__box-title" />
                <span className="mortgage-request-moving-expenses__box-title-separator"></span>
                <div className={boxAmountClasses}>
                    {valueWithCurrency}
                    <FormattedText
                        value="mortgageRequestMovingExpenses-mortgageRequestMovingExpenses_feePeriodicity"
                        className="mortgage-request-moving-expenses__box-fee-periodicity"
                    />
                </div>
                <FormattedText
                    value="mortgageRequestMovingExpenses-mortgageRequestMovingExpenses_monthlyFee"
                    className="mortgage-request-moving-expenses__box-monthly-fee" />
                <i className={boxIconClasses} />
            </React.Fragment>
        );

        const content = config.isFetching ? <LoadingSection /> : boxContent;

        return (
            <div className={boxClasses} onClick={this.handleSelectBox} data-type={boxType}>
                {content}
            </div>
        );
    }

    handleBackToPanel() {
        this.props.history.goBack();
    }

    render() {
        const { immMortgageRequestMovingExpensesData, immMortgageRequestMortgageData } = this.props;
        const { financeExpensesValue, selectedOffer, isTermsChecked } = this.state;
        const maxFinanceExpensesValue = immMortgageRequestMortgageData.getIn(['data', 'maximoImporteFinanciarGastos']);
        const newOfferSelected = selectedOffer === NEW_OFFER;
        const currentOfferSelected = selectedOffer === CURRENT_OFFER;
        const isFetching = immMortgageRequestMovingExpensesData.get('isFetching');
        const leftBoxConfig = {
            isLeftBox: true,
            selected: currentOfferSelected,
        };
        const rightBoxConfig = {
            isLeftBox: false,
            selected: newOfferSelected,
            isFetching
        };
        const leftBox = this.buildBox(leftBoxConfig);
        const rightBox = this.buildBox(rightBoxConfig);
        const termsLabel = (
            <FormattedText
                value="mortgageRequestMovingExpenses-termsLabel"
                className="mortgage-request-moving-expenses__terms-check-label"
            />
        );
        const maxLabel = (
            <FormattedText
                value="mortgageRequestMovingExpenses-mortgageRequestMovingExpenses_max"
                injectedStrings={[maxFinanceExpensesValue]}
            />
        );
        const termsClasses = classNames(
            'mortgage-request-moving-expenses__terms',
            {
                'mortgage-request-moving-expenses__terms--hidden': selectedOffer !== NEW_OFFER
            }
        );

        const btnSaveDisabled = !selectedOffer || (newOfferSelected && !isTermsChecked);
        const btnIsLoading = immMortgageRequestMovingExpensesData.get('isSaving');

        const textValue = text();
        const formattedMaxFinanceExpenses = MortgageRequestCurrencyHelp({ currency: maxFinanceExpensesValue, withDecimals: false });
        const title = formatText('mortgageRequestMovingExpenses-mortgageRequestMovingExpenses_title', [formattedMaxFinanceExpenses]);

        return (
            <ContentBox>
                <div className="mortgage-request-moving-expenses__title">
                    <OKBoxTitle value={title} />
                </div>
                <div className="mortgage-request-moving-expenses__subtitle">
                    <FormattedText value="mortgageRequestMovingExpenses-mortgageRequestMovingExpenses_subtitle" />
                </div>
                <div className="mortgage-request-moving-expenses__simulate-label">
                    <FormattedText value="mortgageRequestMovingExpenses-mortgageRequestMovingExpenses_simulateLabel" />
                </div>
                <span className="mortgage-request-moving-expenses__label">
                    {textValue.LABEL.EXTRA_AMOUNT}
                </span>
                <div className="row mortgage-request-moving-expenses__slider-container">
                    <div className="col-xs-10">
                        <div className="mortgage-request-moving-expenses__slider">
                            <OKSliderInput
                                defaultValue={financeExpensesValue}
                                inputType="format"
                                max={maxFinanceExpensesValue}
                                maxLabel={maxLabel}
                                onChange={this.handleChangeSliderValue}
                                unit={EURO_SYMBOL}
                                valueLabelType="label"
                            />
                        </div>
                    </div>
                    <div className="col-xs-2 mortgage-request-moving-expenses__calc-button">
                        <OKButton
                            modifier="primary"
                            onClick={this.handleCalculate}
                            loading={isFetching}
                        >
                            <FormattedText value="mortgageRequestCommons-calcularText" />
                        </OKButton>
                    </div>
                </div>
                <div className="row mortgage-request-moving-expenses__box-container">
                    <div className="row ">
                        <div className="col-xs-5 col-xs-offset-1">
                            {leftBox}
                        </div>
                        <div className="col-xs-5">
                            {rightBox}
                        </div>
                    </div>
                </div>
                <div className={termsClasses}>
                    <FormattedText
                        value="mortgageRequestMovingExpenses-mortgageRequestMovingExpenses_termsHeading"
                        className="mortgage-request-moving-expenses__terms-label"
                    />
                    <ul className="mortgage-request-moving-expenses__terms-list">
                        <li><FormattedText value="mortgageRequestMovingExpenses-mortgageRequestMovingExpenses_termsOne" /></li>
                        <li><FormattedText value="mortgageRequestMovingExpenses-mortgageRequestMovingExpenses_termsTwo" /></li>
                    </ul>
                    <div className="mortgage-request-moving-expenses__terms-check">
                        <OKCheckbox
                            idName="movingTerms"
                            value={isTermsChecked}
                            onChange={this.handleTermsChanged}
                            label={termsLabel}
                        />
                    </div>
                </div>
                <div className="mortgage-request-moving-expenses__buttons">
                    <div className="pull-left">
                        <OKLink modifier="inherit-styles" name={'returnLink'}
                            onClick={() => this.handleBackToPanel()}
                        >
                            {textValue.LABEL.BACK}
                        </OKLink>
                    </div>
                    <OKButton
                        id="mortgage-request-estates-view__save-button"
                        modifier="primary"
                        onClick={this.handleOnSave}
                        children={textValue.LABEL.ACCEPT}
                        disabled={btnSaveDisabled}
                        loading={btnIsLoading}
                    />
                </div>
            </ContentBox>
        );
    }
}

MortgageRequestMovingExpenses.propTypes = {
    history: PropTypes.object.isRequired,
    immMortgageRequestMortgageData: PropTypes.object.isRequired,
    immMortgageRequestMovingExpensesData: PropTypes.object.isRequired,
    onCalculateMovingFee: PropTypes.func.isRequired,
    onAcceptMovingFee: PropTypes.func.isRequired
}

module.exports = withRouter(MortgageRequestMovingExpenses);
